import { fastDealsRequestConstructor } from '@monorepo/fast-deals';
import { FastDealService } from 'order_ts/v1/order_web/fast_deal_web_pb_service';

const getFastDeals = (filter: object | null) =>
  fastDealsRequestConstructor(filter, FastDealService.ListFastDeal);

export default getFastDeals;
